module.exports = __webpack_public_path__ + "static/media/trainingslevel_icon.0090973c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/trainingslevel_icon.svg
// module id = 133
// module chunks = 0